import {appApi} from './api.service';
import {Preferences} from "@capacitor/preferences";

const MomentRange = require('moment-range');
const Moment = require('moment-timezone');
const moment = MomentRange.extendMoment(Moment);
moment.tz.setDefault('Europe/Warsaw');

interface ServerDateResponse {
    date: string;
    timezone: string;
    timestamp: number;
}

const OFFSET_PREF_KEY = 'server_time_offset_ms';

let serverOffsetMs: number | null = null;

export const syncServerDate = async (): Promise<void> => {
    try {
        const response = await appApi.get('/server-date', {
            timeout: 15000
        });
        const data = response.data as ServerDateResponse;

        serverOffsetMs = data.timestamp * 1000 - Date.now();

        await Preferences.set({
            'key': OFFSET_PREF_KEY,
            'value': String(serverOffsetMs)
        });
    } catch (error) {
        console.warn('Server date sync failed, using last known offset:', error);
    }
};

const loadPersistedOffset = async (): Promise<void> => {
    if (serverOffsetMs !== null) {
        return;
    }

    try {
        const {value} = await Preferences.get({'key': OFFSET_PREF_KEY});
        if (value !== null && value !== '' && !isNaN(Number(value))) {
            serverOffsetMs = Number(value);
        }
    } catch (error) {
        console.warn('Failed to load persisted server date offset:', error);
    }
};

export const getServerNow = () => {
    return moment(Date.now() + (serverOffsetMs ?? 0));
};

export const getCurrentServerMoment = async () => {
    return getServerNow();
};

export const getCurrentServerDateString = async (): Promise<string> => {
    return getServerNow().format('YYYY-MM-DD');
};

export const initializeServerDateSync = async (): Promise<void> => {
    await loadPersistedOffset();
    await syncServerDate();
};
